<template>
    <div class="min-h-screen bg-background text-text">
        <MaintenanceBanner/>
        <slot/>
    </div>

</template>

<script lang="ts" setup>

const themeClass = useThemeClass()

useHead(() => ({
    htmlAttrs: {
        class: themeClass.value
    }
}))

</script>

<style scoped lang="scss">
@use '../assets/scss/variables.scss';
@use '../assets/scss/theme.css';

html {
    width: 100vw;
}

body {
    background-color: red;
}
</style>
